module.exports = __webpack_public_path__ + "static/SCAPE-full-dc30b5964fb317208db9d71460dc5395.jpg";